const browser = (() => {
    const test = function(regexp) {return regexp.test(window.navigator.userAgent)}
    switch (true) {
        case test(/edg/i): return "Microsoft Edge";
        case test(/trident/i): return "Microsoft Internet Explorer";
        case test(/firefox|fxios/i): return "Mozilla Firefox";
        case test(/opr\//i): return "Opera";
        case test(/ucbrowser/i): return "UC Browser";
        case test(/samsungbrowser/i): return "Samsung Browser";
        case test(/chrome|chromium|crios/i): return "Google Chrome";
        case test(/safari/i): return "Apple Safari";
        default: return "Other";
    }
})();

if (browser === 'Apple Safari') {
    console.log(browser);
    document.documentElement.classList.add('browser-safari');
}

// Accordion
const accordions = document.querySelectorAll('.js-accordion');
const toggleAccordion = e => {
    const self = e.target
    const content = self.nextElementSibling;
    self.classList.toggle('active');
    content.style.maxHeight ?
        content.style.maxHeight = null :
        content.style.maxHeight = `${content.scrollHeight + 100}px`;
}

accordions.forEach(accordion => {
    accordion.addEventListener('click', toggleAccordion, false);
});


// Tab content
const allTabs = document.querySelectorAll('[data-tab]');
const openTab = e => {
    const self = e.target;
    const parent = self.closest('[data-tab-parent]');
    const contentId = self.dataset.contentId;

    if(!contentId || !parent) return;

    const contents = parent.querySelectorAll('.tabcontent');
    const tabs = parent.querySelectorAll('[data-tab]');

    // Reset: Hide all tab contents and remove active class to all tablinks
    contents.forEach(content => content.style.display = 'none');
    tabs.forEach(tab => tab.classList.remove('active'));

    // Set active class on current tablink and display tabcontent
    self.classList.add('active');
    document.getElementById(contentId).style.display = 'block';
}

allTabs.forEach(tab => {
    tab.addEventListener('click', openTab, false);

    // Initially run and check for default open tab
    if (tab.hasAttribute('data-default')) tab.click();
})


// Custom modals using theme.js Modals
const modals = document.querySelectorAll('.js-modal-trigger');
modals.forEach(modal => {
    let m = new theme.Modals(modal.dataset.contentId, 'tabs');

    modal.addEventListener('click', e => {
        m.open();
    });
});


// Custom flickity free scroll for 'grid-overflow-wrapper' class
function initFlkty(e) {
    const overflowElems = document.querySelectorAll('.grid-overflow-wrapper .grid');
    overflowElems.forEach(elem => {
        new Flickity(elem, {
            freeScroll: true,
            contain: true,
            groupCells: elem.hasAttribute('data-flkty-group-cells'),
            prevNextButtons: elem.hasAttribute('data-flkty-buttons'),
            pageDots: elem.hasAttribute('data-flkty-pagedots')
        });
    });
}
initFlkty();
document.addEventListener('recommendations:loaded', initFlkty, false);


// Run ajax add to cart
const ajaxAddToCart = e => {
    const settings = {
        selectors: {
            triggers: '.js-ajax-add-to-cart',
            parent: '[data-parent]',
            multipleVariant: '[data-variants]',
            singleVariant: '[data-single-variant]'
        }
    }

    const submitToCart = async (url, data) => {
        let response = await fetch(url, {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return await response.json();
    };

    const timeout = ms => {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    const addToCart = e => {
        const url = window.theme.routes.cartAdd ? window.theme.routes.cartAdd : '/cart/add.js';
        const self = e.target;
        const parent = self.closest(settings.selectors.parent);
        const multi = parent.querySelector(settings.selectors.multipleVariant);
        const single = parent.querySelector(settings.selectors.singleVariant);

        let variantId = multi?.value ? multi.value :
                        single?.value ? single.value : null;

        let data = {
            'items': [{
                'id': variantId,
                'quantity': 1
            }]
        };

        if (!variantId) return

        self.textContent = 'Adding...';

        submitToCart(url, data)
            .then(async data => {
                self.textContent = 'Done!';
                await timeout(1000);
                self.textContent = self.dataset.text;

                document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                    detail: {
                        product: data
                    }
                }));
            })
            .catch(async error => {
                console.error('There has been a problem with your fetch operation:', error);

                self.classList.add('error');
                self.textContent = 'Not added!';
                await timeout(1000);
                self.textContent = self.dataset.text;
                self.classList.remove('error');
            });
    }

    const triggers = document.querySelectorAll(settings.selectors.triggers);
    for (let btn of triggers) {
        btn.addEventListener('click', addToCart, false);
    }
}

window.addEventListener('load', ajaxAddToCart, false);

// GIFT WITH PURCHASE
window.addEventListener('DOMContentLoaded', () => {
    
    $(document).on('click', '.gwp-drawer-toggle', (e) => {
        let btn = e.currentTarget;
        let parent = btn.closest('.cart__gwp');
        let drawer = parent.querySelector('.gwp-drawer');

        if (drawer.classList.contains('active')) {
            drawer.classList.remove('active')
        } else {
            drawer.classList.add('active')
        }
    })

    function addFreeGiftToCart(variant_id, giftTier) {
        let data = {
            "id": variant_id,
            "quantity": 1,
            "properties": {
                "_freeGift": "true",
                "_giftTier": giftTier
            }
        }
        
        jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function() { 
                document.dispatchEvent(new CustomEvent('cart:updated'));
                document.dispatchEvent(new CustomEvent('cart:build'));
            }
        });
    }

    $(document).on('click', '.add-gift-to-cart', (e) => {
        let atcBtn = e.currentTarget;
        let parent = atcBtn.closest('.gwp-product-item');
        let selector = parent.querySelector('.variant-select');

        let giftTier = parent.getAttribute('data-gift-tier');

        let selected_variant = selector.options[selector.selectedIndex].value;

        if (!selected_variant || selected_variant == '') {
            return;
        }

        addFreeGiftToCart(selected_variant, giftTier);
    })

    document.addEventListener('cart:updated', () => {
        theme.cart.checkUndiscountedGifts();
    })
})